import axios from 'axios';

export interface RequestKakaoAccessTokenResponse {
  token_type: string;
  access_token: string;
  id_token?: string;
  expires_in: number;
  refresh_token: string;
  refresh_token_expires_in: number;
  scope?: string;
}

export interface GetKakaoUserDataResponse {
  id: number;
  has_signed_up: boolean;
  connected_at: number;
  synched_at: number;
  properties: string;
  kakao_account: KakaoAccount;
  for_partner: string;
}

export interface KakaoAccount {
  id: number;
  email: string;
  name?: string | null;
  nickname: string;
  profile_image_url: string;
  thumbnail_image_url: string;
  phone_number?: string | null;
  age_range?: string | null;
  birthday?: string | null;
  birthday_type?: string | null;
  birthyear?: string | null;
  gender?: string | null;
  is_email_valid: boolean;
  is_email_verified: boolean;
  is_korean?: boolean;
  age_range_needs_agreement?: boolean;
  birthday_needs_agreement?: boolean;
  birthyear_needs_agreement?: boolean;
  email_needs_agreement?: boolean;
  gender_needs_agreement?: boolean;
  is_korean_needs_agreement?: boolean;
  phone_number_needs_agreement?: boolean;
  profile_needs_agreement?: boolean;
  ci_needs_agreement?: boolean;
  name_needs_agreement?: boolean;
  profile_image_needs_agreement?: boolean;
  profile_nickname_needs_agreement?: boolean;
  legal_birthdate_needs_agreement?: boolean;
  connected_at?: number;
  synched_at?: number;
}

/**
 * @description 카카오 인가 코드 요청 (카카오 로그인의 경우 OAuth 인증 과정에서 브라우저의 리다이렉션이 필수적이라 단순 axios 요청으로는 처리할 수 없음)
 * @docs https://developers.kakao.com/docs/latest/ko/kakaologin/rest-api#request-code
 */
export const requestKakaoAuthCode = async () => {
  const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.KAKAO_API_KEY}&redirect_uri=${window.location.origin}/login&response_type=code`;
  window.location.replace(kakaoAuthUrl);
};

/**
 * @description 카카오 액세스 토큰 요청
 * @docs https://developers.kakao.com/docs/latest/ko/kakaologin/rest-api#request-token
 */
export const requestKakaoAccessToken = async (verificationCode: string) => {
  const { data } = await axios.post<RequestKakaoAccessTokenResponse>(
    'https://kauth.kakao.com/oauth/token',
    {
      grant_type: 'authorization_code',
      client_id: process.env.KAKAO_API_KEY,
      redirect_uri: `${window.location.origin}/login`,
      code: verificationCode,
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }
  );

  return data;
};
